module.exports = __webpack_public_path__ + "426c7616e4c175fa8263cc66da20f353.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2023_chart.png
// module id = 1674
// module chunks = 0